// extracted by mini-css-extract-plugin
module.exports = {"statistics-data":"statistics-data-03af92a710d75db8baaac7ef2aec0e1f"};